import { all } from "redux-saga/effects";
import loggedInUserSaga from "../loggedInUser/duck/loggedInUserSaga";

function* rootSaga() {
  yield all([loggedInUserSaga()]);
}

export default rootSaga;
